import { PERMISSIONS } from '../../../Permissions'
import { RESPONSE_TYPE, RESPONSE_STATE } from './evaluationForm.constants'

export const userCanEvaluate = (values, authenticatedUser) => {
  const { hasPermission, user } = authenticatedUser

  if (!hasPermission(PERMISSIONS.EVALUATE_QUALITY_CONTACT)) {
    return false
  }

  if (values && values.isScoreCounted === true) { // this is not a calibration
    if (hasPermission(PERMISSIONS.EDIT_ANY_EVALUATION)) {
      return true
    }

    // is user contact agent and can user self evaluate their own contact
    if (
      values &&
      values.agent &&
      user.id === values.agent.id &&
      !hasPermission(PERMISSIONS.SELF_EVALUATE_QUALITY_CONTACT)
    ) {
      return false
    }
    // is user not the evaluator on the form (we know they do not have Edit Any Evaluation)
    if (values && values.evaluator && values.evaluator.id !== user.id) {
      return false
    }
  }

  return true
}

export const userCanEdit = (values, authenticatedUser) => {
  const { hasPermission, user } = authenticatedUser

  return (
    (values && values.evaluator && values.evaluator.id === user.id) ||
    hasPermission(PERMISSIONS.EDIT_ANY_EVALUATION)
  )
}

export const userCanApprove = (values, authenticatedUser) => {
  const { hasPermission, hasAnyPermission, user } = authenticatedUser

  /**
   * If I'm an evaluator and I'm scoring other peoples calls, I
   * should NEVER be able to approve an evaluation where I was the
   * evaluator.
   *
   * I should only be able to approve an evaluation where I was the
   * evaluator if it was my contact in general AND I have the self
   * approve permission.
   *
   * The self (evaluate / approve) permissions are for the use case
   * where agents are allowed to score their own calls and the
   * evaluation needs to be approved.
   */
  if (
    values &&
    values.evaluator &&
    values.evaluator.id === user.id &&
    values.agent &&
    values.agent.id !== user.id
  ) {
    return false
  }

  // User cannot approve/reject if they were the agent and don't have self-approve permission
  if (
    values &&
    values.agent &&
    values.agent.id === user.id &&
    !hasPermission(PERMISSIONS.SELF_APPROVE_QUALITY_CONTACT)
  ) {
    return false
  }

  return hasAnyPermission([PERMISSIONS.APPROVE_QUALITY_CONTACT, PERMISSIONS.SELF_APPROVE_QUALITY_CONTACT])
}

export const userCanAcknowledge = (values, template, calibrationView, authenticatedUser) => {
  const { user } = authenticatedUser

  return (
    template !== null &&
    !calibrationView &&
    values &&
    values.agent &&
    values.agent.id === user.id &&
    (template.responseType.id === RESPONSE_TYPE.ACKNOWLEDGE || template.responseType.id === RESPONSE_TYPE.APPEAL) &&
    values.responseState &&
    values.responseState.stateId === RESPONSE_STATE.PENDING_RESPONSE
  )
}

export const userCanAppeal = (values, template, calibrationView, authenticatedUser) => {
  const { user } = authenticatedUser

  return (
    template !== null &&
    !calibrationView &&
    values &&
    values.agent &&
    values.agent.id === user.id &&
    template.responseType.id === RESPONSE_TYPE.APPEAL &&
    values.responseState &&
    values.responseState.stateId === RESPONSE_STATE.PENDING_RESPONSE
  )
}

export const userCanComment = authenticatedUser => {
  const { hasPermission } = authenticatedUser

  return hasPermission(PERMISSIONS.CREATE_COMMENT_EVALUATION)
}

export const userCanEditComment = authenticatedUser => {
  const { hasPermission } = authenticatedUser

  return hasPermission(PERMISSIONS.EDIT_COMMENT_EVALUATION)
}

export const userCanCalibrate = (values, authenticatedUser) => {
  const { hasPermission, user } = authenticatedUser

  if (
    values &&
    values.agent &&
    values.agent.id === user.id &&
    !hasPermission(PERMISSIONS.SELF_CALIBRATE_CONTACT)
  ) {
    return false
  }
  return hasPermission(PERMISSIONS.CALIBRATE_CONTACT)
}
